import React, { useContext, useEffect, useState } from 'react'
import { LanguageContext } from '../../context/languageContext';
import { componentsNamesFactoryForTitle } from '../../Helper_functions/Languages/LanguageSelector';
import { LanguageIdContext } from '../../context/languageIdContext';



interface Table_Int{
    tally_1:number,
    tally_2:number,
    tally_3:number,
    tally_4:number
}


// just 
export default function Table({tally_1,tally_2,tally_3,tally_4}:Table_Int) {
  
    // context
    
    const { languageId } = useContext(LanguageIdContext);
    const [total, setTotal] = useState(0);
    useEffect(() => {
      setTotal(tally_1+tally_2+tally_3+tally_4);
    }, [languageId]);


  let largest_num = Math.max(tally_1,tally_2,tally_3,tally_4)
  return (
    <table className="table table-bordered">
      <thead>
        <tr>
          <th scope="col">#</th>
          <th scope="col">{componentsNamesFactoryForTitle(languageId,"Total Answers")}</th>
          <th scope="col">{componentsNamesFactoryForTitle(languageId,"Multilingualism Type")}</th>
        </tr>

        
      </thead>
      <tbody>
        <Row_component c1={1} c2={tally_1+"/"+total} c3={componentsNamesFactoryForTitle(languageId,"Limited")} highlighted={tally_1 ==largest_num}/>
        <Row_component c1={2} c2={tally_2+"/"+total} c3={componentsNamesFactoryForTitle(languageId,"Shifting")} highlighted={tally_2 ==largest_num}/>
        <Row_component c1={3} c2={tally_3+"/"+total} c3={componentsNamesFactoryForTitle(languageId,"Shifted")} highlighted={tally_3 ==largest_num}/>
        <Row_component c1={4} c2={tally_4+"/"+total} c3={componentsNamesFactoryForTitle(languageId,"Widespread")} highlighted={tally_4 ==largest_num}/>
        
      </tbody>
    </table>
  );
}


interface row_component_int{
  c1:number,
  c2:any,
  c3:string,
  highlighted:boolean
}
const Row_component = ({c1,c2,c3,highlighted}:row_component_int):JSX.Element=>{
  
 
  if(highlighted){
    return(
    <tr className="table-primary">
            <th scope="row">{c1}</th>
            <td>{c2}</td>
            <td>{c3}</td>
    </tr>
    )
  }else{
   return ( <tr>
            <th scope="row">{c1}</th>
            <td>{c2}</td>
            <td>{c3}</td>
    </tr>
    )
  }
}
